import React from "react";
import { Clock, Calendar, CalendarDays, CalendarRange, ShieldCheck } from "lucide-react";
import { useProductInfo } from "../../hooks/useProductInfo";
import { useListingTypeConfig } from "../../hooks/useListingTypeConfig";
import OfferCount from "../../../ProductCard/childComponents/OfferCount";
import "./styles/PricingCard.css";

const TIER_ICONS: Record<string, React.ReactNode> = {
  "Per Hour": <Clock size={16} />,
  "Per Day": <Calendar size={16} />,
  "Per Week": <CalendarDays size={16} />,
  "Per Month": <CalendarRange size={16} />,
};

const PricingCard: React.FC = () => {
  const { listingType, price, isNegotiable, likesCount, rentalPricing, details } = useProductInfo();
  const { listingTypeConfig } = useListingTypeConfig(listingType);

  const pricingModel = listingTypeConfig?.pricing?.model;
  const isRental = pricingModel === "rental_tiered";

  if (!isRental) return null;

  const depositAmount = details?.deposit_amount;

  if (!hasRentalTiers) {
    if (!price) return null;
    return (
      <div className="prcv2 glass-card">
        <div className="prcv2__header">
          <span className="prcv2__label">Price</span>
          {likesCount > 0 && <OfferCount count={likesCount} />}
        </div>
        <div className="prcv2__tiers">
          <div className="prcv2__tier">
            <div className="prcv2__tier-info">
              <span className="prcv2__tier-value">₹{Number(price).toLocaleString("en-IN")}</span>
              {isNegotiable && <span className="prcv2__tier-label">Negotiable</span>}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="prcv2 glass-card">
      <div className="prcv2__header">
        <span className="prcv2__label">Rental Pricing</span>
        {likesCount > 0 && <OfferCount count={likesCount} />}
      </div>

      <div className="prcv2__tiers">
        {rentalPricing.map((tier) => (
          <div key={tier.label} className="prcv2__tier">
            <div className="prcv2__tier-icon">
              {TIER_ICONS[tier.label] ?? <Clock size={16} />}
            </div>
            <div className="prcv2__tier-info">
              <span className="prcv2__tier-label">{tier.label}</span>
              <span className="prcv2__tier-value">₹{Number(tier.value).toLocaleString("en-IN")}</span>
            </div>
          </div>
        ))}
      </div>

      {depositAmount && (
        <div className="prcv2__deposit">
          <ShieldCheck size={16} />
          <span className="prcv2__deposit-label">Security Deposit</span>
          <span className="prcv2__deposit-value">₹{Number(depositAmount).toLocaleString("en-IN")}</span>
        </div>
      )}
    </div>
  );
};

export default PricingCard;
